import React from 'react'

import Image from '@/image.js'

const TeamMembers = ({ content }) => (
  <div className='container--xl mxa p15 ac'>
    <h2 className=''>{content.title}</h2>
    <div className='team__members f jcb ais fw'>
      {content.teamMembers.map(person => (
        <div key={person._rev} className='x al py05 mb05'>
          <Image imageId={person.imageId} alt={person.name} />
          <h5 className='m0 medium pt05'>{person.name}</h5>
          <span>{person.position}</span>
        </div>
      ))}
      <div />
      <div />
    </div>
  </div>
)

export default TeamMembers